// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgCoolingFreezingIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M16.667 1.889C17.955 1.889 19 2.922 19 4.197V19.58c0 1.275-1.044 2.308-2.333 2.308H7.333C6.045 21.889 5 20.856 5 19.58V4.197c0-1.275 1.045-2.308 2.333-2.308zM6.556 19.58c0 .425.348.77.777.77h9.334c.43 0 .777-.345.777-.77v-9.23H6.556zm2.333-7.692c.43 0 .778.345.778.77v2.307a.774.774 0 0 1-.778.769.773.773 0 0 1-.778-.769v-2.308c0-.424.348-.769.778-.77ZM7.333 3.427a.774.774 0 0 0-.777.77v4.615h10.888V4.197a.774.774 0 0 0-.777-.77zm1.556 1.54c.43 0 .778.343.778.768v.77a.774.774 0 0 1-.778.769.774.774 0 0 1-.778-.77v-.77c0-.424.348-.768.778-.768Z" />
  </g>
);
export default SvgCoolingFreezingIcon;
SvgCoolingFreezingIcon.displayName = 'SvgCoolingFreezingIcon';
